import { defineAction, defineApiCallAction } from "../../libs/rd-action-creators";
import { AssetAttributeFormMeta } from "./adUnitAssetBuilderForm";

export const AddAdUnitBuilderAssetAction = defineAction<{ assetPropery: string }>("AD UNIT BUILDER: ADD ASSET");

export const RemoveAdUnitBuilderAssetAction = defineAction<{ assetPropery: string; index: number }>(
    "AD UNIT BUILDER: REMOVE ASSET"
);

export const CleanAdUnitBuilderAssetAction = defineAction("AD UNIT BUILDER: CLEAN ASSET");

export const BuildAdUnit = defineApiCallAction("AD UNIT BUILDER: BUILD AD UNIT");

export const UploadFileForAssetAction = defineAction<{
    file: File;
    fieldName: string;
    meta: AssetAttributeFormMeta;
    currentValue?: string[];
    uploadingFileId: string;
}>("AD UNIT BUILDER: UPLOAD FILE FOR ASSET");

export const AdUnitFileUploadingStatusChangesAction = defineAction<{ uploadingFileId: string | undefined }>(
    "AD UNIT BUILDER: FILE UPLOADING STATUS CHANGE"
);

export const emptyExistingAdUnitAction = defineAction("EMPTY EXISTING AD UNIT");
